import React from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col, Table, Divider, message, Form, Upload, Icon, Button, Tooltip, Input, Modal } from 'antd';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import ErrorContainer from './../components/FormErrorContainer';

const FormItem = Form.Item;

const UpdateDatasetForm = Form.create({ name: 'form_in_modal' })(
  // eslint-disable-next-line
  class extends React.Component {
    render() {
      const { visible, onCancel, onUpdate, form, selectedDataset } = this.props;
      const { getFieldDecorator } = form;
      return (
        <Modal title="Edit Existing Dataset" okText="Update" visible={visible} onOk={onUpdate} onCancel={onCancel}>
          <Form>
            <FormItem
              label={
                <span>
                  Name&nbsp;
                  <Tooltip title="The unique name of new dataset. Please set a lowercase text with no special character and space.">
                    <Icon type="question-circle-o" />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('name', {
                initialValue: selectedDataset ? selectedDataset.name : '',
                rules: [
                  {
                    required: true,
                    message: 'Please input a name for dataset!',
                    whitespace: true,
                  },
                ],
              })(<Input />)}
            </FormItem>
            <FormItem label={<span>Liability Claim&nbsp;</span>}>
              {getFieldDecorator('liabilityClaim', {
                initialValue: selectedDataset ? selectedDataset.liabilityClaim : '',
                rules: [
                  {
                    required: true,
                    message: 'Please input a liability claim for dataset!',
                  },
                ],
              })(<Input />)}
            </FormItem>
            <FormItem label={<span>Citation&nbsp;</span>}>
              {getFieldDecorator('citation', {
                initialValue: selectedDataset ? selectedDataset.citation : '',
                rules: [
                  {
                    required: true,
                    message: 'Please input a citation for dataset!',
                  },
                ],
              })(<Input />)}
            </FormItem>
            <FormItem label={<span>Documentation link&nbsp;</span>}>
              {getFieldDecorator('documentationLink', {
                initialValue: selectedDataset ? selectedDataset.documentationLink : '',
                rules: [
                  {
                    required: true,
                    message: 'Please input a link for the documentation of the dataset!',
                  },
                ],
              })(<Input />)}
            </FormItem>
          </Form>
        </Modal>
      );
    }
  }
);

@inject('dataStore')
@observer
class SubmitDataset extends React.Component {
  static propTypes = {
    dataStore: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    const data = [];
    const footer = () => `There is no dataset available.`;
    this.state = {
      footer,
      data,
      logoUrl: null,
      logoLoading: false,
      logoObj: null,
      meanUrl: null,
      meanLoading: false,
      meanObj: null,
      p02Url: null,
      p02Loading: false,
      p02Obj: null,
      p16Url: null,
      p16Loading: false,
      p16Obj: null,
      p50Url: null,
      p50Loading: false,
      p50Obj: null,
      p84Url: null,
      p84Loading: false,
      p84Obj: null,
      p98Url: null,
      p98Loading: false,
      p98Obj: null,
      modalVisible: false,
      selectedDataset: null,
    };
  }
  componentWillMount() {
    const { dataStore } = this.props;

    dataStore.getDatasetList().then(() => {
      this.setState({
        data: dataStore.datasetList,
        footer: () =>
          `There are ${dataStore.datasetList.length} dataset${dataStore.datasetList.length === 1 ? '' : 's'}`,
      });
    });
  }
  handleDelete = (e, name) => {
    e.preventDefault();
    const { dataStore } = this.props;

    this.props.dataStore.deleteDataset(name).then(() => {
      if (this.props.dataStore.deletingError) {
        message.error(this.props.dataStore.deleteError.type);
        return;
      }

      message.success('Dataset has been successfully deleted.');
      // Updates dataset list
      dataStore.getDatasetList().then(() => {
        this.setState({
          data: dataStore.datasetList,
          footer: () =>
            `There are ${dataStore.datasetList.length} dataset${dataStore.datasetList.length === 1 ? '' : 's'}`,
        });
      });
    });
  };

  openEditModal = (e, record) => {
    e.preventDefault();
    this.setState({
      modalVisible: true,
      selectedDataset: record,
    });
  };

  handleEditDatasetModalCancel = () => {
    this.setState({
      modalVisible: false,
    });
  };

  onUpdateDataset = () => {
    const form = this.formRef.props.form;
    const { dataStore } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      // send to backend here
      dataStore.updateDataset(this.state.selectedDataset.id, values).then(() => {
        dataStore.getDatasetList().then(() => {
          this.setState({
            data: dataStore.datasetList,
            footer: () =>
              `There are ${dataStore.datasetList.length} dataset${dataStore.datasetList.length === 1 ? '' : 's'}`,
          });
        });
        message.success('Dataset successfully updated.');
      });

      form.resetFields();
      this.setState({
        modalVisible: false,
      });
    });
  };

  saveFormRef = formRef => {
    this.formRef = formRef;
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      this.setState(() => {
        if (
          !err &&
          !!this.state.logoObj &&
          !!this.state.meanObj &&
          !!this.state.p02Obj &&
          !!this.state.p16Obj &&
          !!this.state.p50Obj &&
          !!this.state.p84Obj &&
          !!this.state.p98Obj
        ) {
          this.props.dataStore
            .submit({
              ...values,
              logo: this.state.logoObj,
              mean: this.state.meanObj,
              p02: this.state.p02Obj,
              p16: this.state.p16Obj,
              p50: this.state.p50Obj,
              p84: this.state.p84Obj,
              p98: this.state.p98Obj,
            })
            .then(() => {
              if (!this.props.dataStore.datasetSubmitError) {
                message.success('Dataset submission successful, refresing the page...', 1.5);
                setTimeout(() => this.props.history.push('/submit-dataset'), 1500);
              }
            });
        } else {
          this.props.dataStore.datasetSubmitError = {
            type: 'missingFieldError',
            details: ['Please select the all XML files for dataset submission.'],
          };
        }
      });
    });
  };

  handleLogoChange = file => {
    this.setState(
      {
        logoLoading: true,
      },
      () => {
        const reader = new FileReader();

        reader.addEventListener('load', () =>
          this.setState({
            logoObj: file,
            logoUrl: reader.result,
            logoLoading: false,
          })
        );

        reader.readAsDataURL(file);
      }
    );

    return false;
  };

  handleMeanChange = file => {
    this.setState(
      {
        meanLoading: true,
      },
      () => {
        const reader = new FileReader();

        reader.addEventListener('load', () =>
          this.setState({
            meanObj: file,
            meanUrl: reader.result,
            meanLoading: false,
          })
        );

        reader.readAsDataURL(file);
      }
    );

    return false;
  };

  handleP02Change = file => {
    this.setState(
      {
        p02Loading: true,
      },
      () => {
        const reader = new FileReader();

        reader.addEventListener('load', () =>
          this.setState({
            p02Obj: file,
            p02Url: reader.result,
            p02Loading: false,
          })
        );

        reader.readAsDataURL(file);
      }
    );

    return false;
  };

  handleP16Change = file => {
    this.setState(
      {
        p16Loading: true,
      },
      () => {
        const reader = new FileReader();

        reader.addEventListener('load', () =>
          this.setState({
            p16Obj: file,
            p16Url: reader.result,
            p16Loading: false,
          })
        );

        reader.readAsDataURL(file);
      }
    );

    return false;
  };

  handleP50Change = file => {
    this.setState(
      {
        p50Loading: true,
      },
      () => {
        const reader = new FileReader();

        reader.addEventListener('load', () =>
          this.setState({
            p50Obj: file,
            p50Url: reader.result,
            p50Loading: false,
          })
        );

        reader.readAsDataURL(file);
      }
    );

    return false;
  };

  handleP84Change = file => {
    this.setState(
      {
        p84Loading: true,
      },
      () => {
        const reader = new FileReader();

        reader.addEventListener('load', () =>
          this.setState({
            p84Obj: file,
            p84Url: reader.result,
            p84Loading: false,
          })
        );

        reader.readAsDataURL(file);
      }
    );

    return false;
  };

  handleP98Change = file => {
    this.setState(
      {
        p98Loading: true,
      },
      () => {
        const reader = new FileReader();

        reader.addEventListener('load', () =>
          this.setState({
            p98Obj: file,
            p98Url: reader.result,
            p98Loading: false,
          })
        );

        reader.readAsDataURL(file);
      }
    );

    return false;
  };

  render() {
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: text => text,
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <span>
            <a href="#" onClick={e => this.openEditModal(e, record)}>
              Edit
            </a>
            <Divider type="vertical" />
            <a href="#" onClick={e => this.handleDelete(e, record.name)}>
              Delete{' '}
            </a>
          </span>
        ),
      },
    ];
    const { dataStore } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Row type="flex" justify="center">
          <Divider>Currently Available Datasets</Divider>
          <Col xs={24} sm={12} lg={12}>
            <Table
              {...this.state}
              loading={dataStore.loadingDatasetList}
              columns={columns}
              rowKey="id"
              dataSource={Array.from(this.state.data)}
            />
          </Col>
          <Divider> Add New Dataset </Divider>
          <Col xs={24} sm={12} lg={12}>
            <Form onSubmit={this.handleSubmit}>
              <FormItem label="Logo">
                <Upload name="logo" beforeUpload={this.handleLogoChange}>
                  <Button>
                    <Icon type="upload" /> Select the logo for the dataset
                  </Button>
                </Upload>
              </FormItem>
              <FormItem
                label={
                  <span>
                    Name&nbsp;
                    <Tooltip title="The unique name of new dataset. Please set a lowercase text with no special character and space.">
                      <Icon type="question-circle-o" />
                    </Tooltip>
                  </span>
                }
              >
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input a name for dataset!',
                      whitespace: true,
                    },
                  ],
                })(<Input />)}
              </FormItem>
              <FormItem label={<span>Liability Claim&nbsp;</span>}>
                {getFieldDecorator('liabilityClaim', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input a liability claim for dataset!',
                    },
                  ],
                })(<Input />)}
              </FormItem>
              <FormItem label={<span>Citation&nbsp;</span>}>
                {getFieldDecorator('citation', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input a citation for dataset!',
                    },
                  ],
                })(<Input />)}
              </FormItem>
              <FormItem label={<span>Documentation link&nbsp;</span>}>
                {getFieldDecorator('documentationLink', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input a link to the dataset documentation!',
                    },
                  ],
                })(<Input />)}
              </FormItem>
              <Row>
                <Col xs={24} sm={24} lg={12}>
                  <FormItem label="Mean">
                    <Upload name="mean" beforeUpload={this.handleMeanChange}>
                      <Button>
                        <Icon type="upload" /> Select the `mean` XML File
                      </Button>
                    </Upload>
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} lg={12}>
                  <FormItem label="P02">
                    <Upload name="p02" beforeUpload={this.handleP02Change}>
                      <Button>
                        <Icon type="upload" /> Select the `p02` XML File
                      </Button>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col xs={24} sm={24} lg={12}>
                  <FormItem label="P16">
                    <Upload name="p16" beforeUpload={this.handleP16Change}>
                      <Button>
                        <Icon type="upload" /> Select the `p16` XML File
                      </Button>
                    </Upload>
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} lg={12}>
                  <FormItem label="P50">
                    <Upload name="p50" beforeUpload={this.handleP50Change}>
                      <Button>
                        <Icon type="upload" /> Select the `p50` XML File
                      </Button>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col xs={24} sm={24} lg={12}>
                  <FormItem label="P84">
                    <Upload name="p84" beforeUpload={this.handleP84Change}>
                      <Button>
                        <Icon type="upload" /> Select the `p84` XML File
                      </Button>
                    </Upload>
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} lg={12}>
                  <FormItem label="P98">
                    <Upload name="p98" multiple={false} beforeUpload={this.handleP98Change}>
                      <Button>
                        <Icon type="upload" /> Select the `p98` XML File
                      </Button>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
              <ErrorContainer error={dataStore.datasetSubmitError} />
              <FormItem>
                <Button type="primary" htmlType="submit" loading={dataStore.loadingDataset}>
                  Submit New Dataset
                </Button>
                <Link to="/sample.xml" download target="_blank">
                  <Button type="ghost" style={{ marginLeft: 10 }}>
                    Sample XML File
                  </Button>
                </Link>
              </FormItem>
            </Form>
          </Col>
        </Row>
        <UpdateDatasetForm
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.modalVisible}
          onCancel={this.handleEditDatasetModalCancel}
          onUpdate={this.onUpdateDataset}
          selectedDataset={this.state.selectedDataset}
        />
      </div>
    );
  }
}

const SubmitDatasetForm = Form.create()(SubmitDataset);

export default SubmitDatasetForm;



// WEBPACK FOOTER //
// ./src/screens/SubmitDataset.js